export const TWO_COLIUMN_COMPARE_TABLE = 'TwoColumnComparisonTable'
